<input
  [type]="to.type"
  [attr.aria-required]="to.required"
  [attr.required]="to.required"
  [formControl]="formControl"
  [formlyAttributes]="field"
  class="op-input"
>
